<template>
  <div class="sls-root">
    <div>
      <!-- SOC hero: ring gauge + journey -->
      <div class="soc-card">
        <div class="soc-ring-wrap">
          <svg
            class="soc-ring"
            viewBox="0 0 120 120"
          >
            <circle
              class="soc-ring__track"
              cx="60"
              cy="60"
              r="52"
            />
            <circle
              class="soc-ring__fill"
              cx="60"
              cy="60"
              r="52"
              :stroke-dasharray="circumference"
              :stroke-dashoffset="ringOffset"
            />
          </svg>
          <div class="soc-ring__center">
            <div class="soc-ring__pct">
              {{ currentSoc }}<span class="soc-ring__sym">%</span>
            </div>
            <div class="soc-ring__lbl">
              Battery
            </div>
          </div>
        </div>

        <div class="soc-journey">
          <div class="soc-journey__row">
            <div class="soc-point">
              <div class="soc-point__lbl">
                Start SOC
              </div>
              <div class="soc-point__val">
                {{ startSoc }}%
              </div>
            </div>
            <div class="soc-point soc-point--now">
              <div class="soc-point__lbl">
                Now
              </div>
              <div class="soc-point__val">
                {{ currentSoc }}%
              </div>
            </div>
            <div class="soc-point soc-point--end">
              <div class="soc-point__lbl">
                Target SOC
              </div>
              <div class="soc-point__val">
                {{ targetSoc }}%
              </div>
            </div>
          </div>

          <!-- Linear track: start tick → current fill → target -->
          <div class="soc-track">
            <!-- Gray before Start SOC -->
            <div
              class="soc-track__before"
              :style="{ width: startSoc + '%' }"
            />
            <!-- Green from Start SOC to Current SOC -->
            <div
              class="soc-track__fill"
              :style="{
                left: startSoc + '%',
                width: currentSoc - startSoc + '%',
              }"
            />
            <div
              class="soc-track__tick"
              :style="{ left: startSoc + '%' }"
              title="Start"
            />
            <div
              class="soc-track__target"
              :style="{ left: targetSoc + '%' }"
              title="Target"
            />
          </div>
          <div class="soc-gain">
            +{{ socGained }}% added this session
          </div>
        </div>
      </div>

      <!-- <div class="match-q">
        Estimated remaining time to 100% charge <i>{{ "0 min" }}</i>.
      </div> -->
      <!--  -->

      <!--  -->

      <!-- Stats bar -->
      <div class="live-stats">
        <div class="live-stat">
          <div class="live-stat__val">
            {{ item?.charge_session?.energy_consumed || 0
            }}<span class="live-stat__unit"> kWh</span>
          </div>
          <div class="live-stat__lbl">
            Delivered
          </div>
        </div>
        <!-- <div class="live-stat-div" /> -->
        <div class="live-stat">
          <div class="d-flex justify-center gap5">
            <div
              v-for="(r, i) in convertDuration(
                item?.charge_session?.duration_minutes || 0
              )"
              :key="i"
              class="live-stat__val"
            >
              {{ r.value }}
              <span class="live-stat__unit"> {{ r.unit }}</span>
            </div>
          </div>
          <div class="live-stat__lbl">
            Elapsed
          </div>
        </div>
        <!-- <div class="live-stat-div" /> -->
        <div
          v-if="item.end_time"
          class="live-stat"
        >
          <div class="d-flex justify-center gap5">
            <div
              v-for="(r, i) in convertDuration(getDurationInMin(item.end_time))"
              :key="i"
              class="live-stat__val"
              :class="r.value < 10 ? 'text--red' : ''"
            >
              {{ r.value }}
              <span class="live-stat__unit"> {{ r.unit }}</span>
            </div>
          </div>
          <div class="live-stat__lbl">
            Remaining Slot Time
          </div>
        </div>
        <!-- <div class="live-stat-div" /> -->
        <div class="live-stat">
          <div class="live-stat__val">
            <span
              class="live-stat__unit"
            >{{ item?.charge_session?.currency }}
            </span>
            {{ item?.charge_session?.total_cost || 0 }}
          </div>
          <div class="live-stat__lbl">
            Amount
          </div>
        </div>
      </div>

      <!-- Session details -->
      <div class="success-detail">
        <div class="sd-row">
          <span class="k">Customer</span>
          <span class="v">{{ item.customer_name || "—" }}</span>
        </div>
        <div class="sd-row">
          <span class="k">Vehicle</span>
          <span class="v">
            {{ item.vehicle_make_name }} — {{ item.vehicle_model_name }}
          </span>
        </div>
        <div class="sd-row">
          <span class="k">Reg #</span>
          <span class="v">{{ item.vehicle_reg_no || "—" }}</span>
        </div>
        <div class="sd-row">
          <span class="k">Port</span>
          <span class="v">Port-{{ item.connector_no }}</span>
        </div>
        <div class="sd-row">
          <span class="k">Connector</span>
          <span class="v">
            {{ item.connector_type }} · {{ item.connector_power }} kW
          </span>
        </div>
        <div
          v-if="item.end_time_format"
          class="sd-row"
        >
          <span class="k">Booked until</span>
          <span class="v">{{ item.end_time_format || "—" }}</span>
        </div>
        <div class="sd-row">
          <span class="k">Est. remaining time to 100% charge </span>
          <span class="v">{{ item?.eta_time_to_charge }} 0 min</span>
        </div>
        <!-- <div class="sd-row">
          <span class="k">Booked slot time </span>
          <span class="v">{{ item.slot_duration_minutes }} min</span>
        </div> -->
      </div>
    </div>

    <div>
      <div>
        <button
          class="big-btn btn-primary"
          :disabled="item?.current_status == 'charging'"
          @click="$emit('click', 'take_payment')"
        >
          <!-- @click="() => (selectedFlow = 'take_payment')" -->
          <!-- @click="$emit('go-step', 5)" -->
          Charging done — Take payment
          <v-icon color="white">
            mdi-arrow-right
          </v-icon>
        </button>
      </div>
      <div class="helper-text">
        Come back here when the session ends
      </div>
    </div>
  </div>
</template>

<script>
import { convertDuration, getDurationInMin } from "./bookingHelpers";

export default {
  name: "StateOfCharge",
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    startSoc() {
      return this.clampPct(this.num(this.item?.charge_session?.start_soc, 0));
    },
    targetSoc() {
      // end_soc = target SOC for the session; default to full charge
      // var t = this.num(this.item?.charge_session?.end_soc, this.num(this.item.target_soc, 100));
      return this.clampPct(100);
    },
    currentSoc() {
      // live SOC from OCPP MeterValues; fall back to start if not reported yet
      var c = this.num(
        this.item?.charge_session?.end_soc,
        this.num(this.item?.charge_session?.end_soc, this.startSoc)
      );
      return this.clampPct(c);
    },
    socGained() {
      return Math.max(0, this.currentSoc - this.startSoc);
    },
    circumference() {
      return 2 * Math.PI * 52; // r = 52 in the 120×120 viewBox
    },
    ringOffset() {
      return this.circumference * (1 - this.currentSoc / 100);
    },
  },

  methods: {
    getDurationInMin,
    convertDuration,
    num(v, fallback) {
      var n = Number(v);
      return isNaN(n) || v === null || v === undefined || v === ""
        ? fallback
        : n;
    },
    clampPct(v) {
      return Math.min(100, Math.max(0, Math.round(v)));
    },
  },
};
</script>

<style scoped>
/* ---------- Live header ---------- */
.live-detail-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}
.live-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--gradient);
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1.5px;
  padding: 4px 10px;
  border-radius: 999px;
}
.live-pulse {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  animation: pulse 1.4s ease-in-out infinite;
}
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.35;
    transform: scale(0.7);
  }
}
@media (prefers-reduced-motion: reduce) {
  .live-pulse {
    animation: none;
  }
  .soc-ring__fill {
    transition: none !important;
  }
}
.live-detail-sub {
  font-size: 14px;
  font-weight: 600;
  color: var(--muted);
}

/* ---------- SOC hero ---------- */
.soc-card {
  display: flex;
  align-items: center;
  gap: 20px;
  /* background: #e3ecea; */
  background: var(--gradient);
  /* background: linear-gradient(135deg, var(--teal), rgba(143, 200, 77, 0.06)); */

  /* background: linear-gradient(
    0deg,
    var(--lightGreen),
    rgba(143, 200, 77, 0.06)
  ); */
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 16px;
}
.soc-ring-wrap {
  position: relative;
  width: 128px;
  height: 128px;
  flex: 0 0 auto;
}
.soc-ring {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}
.soc-ring__track {
  fill: none;
  stroke: #fff;
  stroke-width: 10;
}
.soc-ring__fill {
  fill: none;
  stroke: var(--lightGreen);
  stroke-width: 10;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.8s ease;
}
.soc-ring__center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.soc-ring__pct {
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  line-height: 1;
}
.soc-ring__sym {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}
.soc-ring__lbl {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #fff;
  margin-top: 2px;
}

/* Journey: start → now → target */
.soc-journey {
  flex: 1;
  min-width: 0;
}
.soc-journey__row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}
.soc-point__lbl {
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.soc-point__val {
  font-size: 17px;
  font-weight: 800;
  color: #fff;
}
.soc-point--now {
  color: var(--darkGreen);
}
.soc-point--now {
  text-align: center;
}
.soc-point--end {
  text-align: right;
}

.soc-track {
  position: relative;
  height: 8px;
  border-radius: 999px;
  background: #fff;
  overflow: visible;
}
/* .soc-track__fill {
  height: 100%;
  border-radius: 999px;
  background: var(--lightGreen);
  transition: width 0.8s ease;
} */

/* Gray only before Start SOC */
.soc-track__before {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #b1b0aa;
  border-radius: 999px 0 0 999px;
}

.soc-track__fill {
  position: absolute;
  top: 0;
  height: 100%;
  background: var(--lightGreen);
  /* border-radius: 999px; */
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  transition: left 0.8s ease, width 0.8s ease;
}

.soc-track__tick,
.soc-track__target {
  position: absolute;
  top: -3px;
  width: 2px;
  height: 14px;
  border-radius: 2px;
  transform: translateX(-50%);
}
.soc-track__tick,
.soc-track__target {
  background: #000;
  /* opacity: 0.45; */
  /* background: var(--lightGreen); */
}

.soc-gain {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
}

/* ---------- Stats ---------- */
.live-stats {
  /* display: flex;
  align-items: stretch;
  padding: 12px 4px;
  margin-bottom: 16px; */
  border: 1px solid var(--line);
  border-radius: 14px;
  background: #fff;
  flex-wrap: wrap !important;
}
.live-stat {
  border-right: 1px solid var(--line);
  flex: 1;
  text-align: center;
  padding: 0.5rem;
  /* min-width: none; */
}
.live-stat__val {
  /* font-size: clamp(16px, 4.5vw, 20px); */
  /* font-weight: 800; */
  color: #000;
  white-space: nowrap;
}
.live-stat__unit {
  /* font-size: 12px; */
  /* font-weight: 600; */
  color: var(--muted);
}
.live-stat__lbl {
  font-size: 11px;
  font-weight: 600;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-top: 2px;
}
.live-stat-div {
  width: 1px;
  background: var(--muted);
  margin: 2px 0;
}

/* ---------- Detail rows ---------- */
.success-detail {
  border: 1px solid var(--line);
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
}
.sd-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  padding: 11px 14px;
}
.sd-row + .sd-row {
  border-top: 1px solid var(--line);
}
.sd-row .k {
  font-size: 13px;
  font-weight: 600;
  color: var(--muted);
  flex: 0 0 auto;
}
.sd-row .v {
  font-size: 14px;
  font-weight: 700;
  color: var(--muted);
  text-align: right;
  word-break: break-word;
}

/* ---------- Button ---------- */
.big-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 15px 18px;
  border: none;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
}

.helper-text {
  text-align: center;
  font-size: 12px;
  color: var(--muted);
  margin-top: 8px;
}

/* ---------- Mobile ---------- */
/* @media (max-width: 480px) { */
@media (max-width: 1024px) {
  .soc-card {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
    gap: 14px;
  }
  .soc-ring-wrap {
    width: 116px;
    height: 116px;
    margin: 0 auto;
  }
  .soc-journey__row {
    margin-bottom: 8px;
  }
  .soc-point__val {
    font-size: 15px;
  }
  .sd-row {
    padding: 10px 12px;
  }
  .sd-row .k {
    font-size: 12px;
  }
  .sd-row .v {
    font-size: 13px;
  }
  .live-stats {
    background: transparent;
    border: none;
    padding: 0;
    gap: 0.5rem;
  }
  .live-stat {
    background: #fff;
    flex-basis: 49%;
    border-radius: 10px;
    border: 1px solid var(--line);
  }
}
</style>
